import config from 'appconfig';

export default async () => {
  const r = await fetch(`${config.hamletUrl}/1.0/public/creditCard/session`, { method: 'POST' });
  const { creditCardSessionId } = await r.json();
  return creditCardSessionId;
};
